



import {Component, Vue} from 'vue-property-decorator'
import SurveyAttentionList from '@/components/survey/SurveyAttentionList.vue'

@Component({
  components: {
    SurveyAttentionList,
  },
})
export default class Attention extends Vue {}
